import { toGlobalUtc } from "svila-common";
import { InventoryFormikValuesDto } from "../InventoryFormikValuesDto";
import { StockTransactionAddDto } from "../StockTransactionAddDto";

export const formikToTransactionAddDto = (item: InventoryFormikValuesDto, genericId: string): StockTransactionAddDto => {
  const addDto: StockTransactionAddDto = {
    genericProductId: genericId,
    manufacturerId: item.manufacturerId,
    supplierId: item.supplierId,
    accountedPrice: item.accountedPrice ? parseFloat(item.accountedPrice) : null,
    accountedValue: item.accountedValue ? parseFloat(item.accountedValue) : null,
    sellOrderId: item.sellOrderId ? item.sellOrderId : null,
    purchaseOrderId: item.purchaseOrderId ? item.purchaseOrderId : null,
    condition: item.condition,
    status: item.status,
    singleCuUnits: item.singleCuUnits ? parseInt(item.singleCuUnits, 10) : null,
    singleDpUnits: item.singleDpUnits ? parseInt(item.singleDpUnits, 10) : null,
    fullDuUnits: item.fullDuUnits ? parseInt(item.fullDuUnits, 10) : null,
    expirationDate: toGlobalUtc(item.expirationDate),
    productionDate: toGlobalUtc(item.productionDate),
    lot: item.lot || null,
    chamberNumber: parseInt(item.chamberNumber, 10),
    column: parseInt(item.column, 10),
    letter: item.letter,
    level: parseInt(item.level, 10),
    movementType: item.movementType,
    createdOn: null,
    isInvoiced: item.isInvoiced,
    isRemoved: item.isRemoved,
    notes: item.notes,
    transactionDateTime: toGlobalUtc(item.transactionDateTime),
    warehouseOwnerId: item.warehouseOwnerId,
    warehouseId: item.warehouseId,
  };

  return addDto;
};